import {POST_SNAPSHOTS, GET_ALL_SNAPSHOTS} from '../actiontypes';
import {getGroupSnapshotUrl, allGroupSnapshotsUrl} from '../apiUrls';

export const createInstructionSnapshot = (engagementId, isScopeSnapshot) => {
	const url = getGroupSnapshotUrl(engagementId, isScopeSnapshot);

	return {
		type: POST_SNAPSHOTS,
		meta: {
			api: {
				url,
				method: 'POST'
			}
		}
	};
};

export const getAllSnapshots = (engagementId, scopeId, isSentVersion) => {
	const url = `${allGroupSnapshotsUrl(engagementId, scopeId, isSentVersion)}`;
	return {
		type: GET_ALL_SNAPSHOTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};
